"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CreateGift: true,
  SelectCampaign: true,
  NoCampaigns: true,
  Step: true,
  CampaignSummary: true,
  GiftStatus: true,
  PreviewLink: true,
  ProductPriceInput: true,
  ProductPriceDropdown: true,
  MessageCard: true,
  DeliveryAddressForm: true,
  setMarketplaceCountryId: true,
  useMarketplaceCountryEffect: true,
  useCampaignsCountryEffect: true,
  useCampaignsRequest: true
};
Object.defineProperty(exports, "SelectCampaign", {
  enumerable: true,
  get: function get() {
    return _SelectCampaign.default;
  }
});
Object.defineProperty(exports, "NoCampaigns", {
  enumerable: true,
  get: function get() {
    return _NoCampaigns.default;
  }
});
Object.defineProperty(exports, "Step", {
  enumerable: true,
  get: function get() {
    return _Step.default;
  }
});
Object.defineProperty(exports, "CampaignSummary", {
  enumerable: true,
  get: function get() {
    return _CampaignSummary.default;
  }
});
Object.defineProperty(exports, "GiftStatus", {
  enumerable: true,
  get: function get() {
    return _GiftStatus.default;
  }
});
Object.defineProperty(exports, "PreviewLink", {
  enumerable: true,
  get: function get() {
    return _PreviewLink.default;
  }
});
Object.defineProperty(exports, "ProductPriceInput", {
  enumerable: true,
  get: function get() {
    return _ProductPriceInput.default;
  }
});
Object.defineProperty(exports, "ProductPriceDropdown", {
  enumerable: true,
  get: function get() {
    return _ProductPriceDropdown.default;
  }
});
Object.defineProperty(exports, "MessageCard", {
  enumerable: true,
  get: function get() {
    return _MessageCard.default;
  }
});
Object.defineProperty(exports, "DeliveryAddressForm", {
  enumerable: true,
  get: function get() {
    return _DeliveryAddressForm.default;
  }
});
Object.defineProperty(exports, "setMarketplaceCountryId", {
  enumerable: true,
  get: function get() {
    return _marketplace.setMarketplaceCountryId;
  }
});
Object.defineProperty(exports, "useMarketplaceCountryEffect", {
  enumerable: true,
  get: function get() {
    return _useMarketplace.useMarketplaceCountryEffect;
  }
});
Object.defineProperty(exports, "useCampaignsCountryEffect", {
  enumerable: true,
  get: function get() {
    return _useCampaigns.useCampaignsCountryEffect;
  }
});
Object.defineProperty(exports, "useCampaignsRequest", {
  enumerable: true,
  get: function get() {
    return _useCampaigns.useCampaignsRequest;
  }
});
exports.CreateGift = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _root = _interopRequireDefault(require("./store/root.epic"));

var _root2 = _interopRequireDefault(require("./store/root.reducer"));

var selectors = _interopRequireWildcard(require("./store/root.selector"));

var _CreateGiftModule = _interopRequireDefault(require("./CreateGiftModule"));

var _CreateContactModule = _interopRequireDefault(require("./CreateContactModule"));

var _SelectCampaign = _interopRequireDefault(require("./components/SelectCampaign/SelectCampaign"));

var _SendGiftModule = _interopRequireDefault(require("./SendGiftModule"));

var _EditContactModule = _interopRequireDefault(require("./EditContactModule"));

var _ContactEnrichmentModule = _interopRequireDefault(require("./ContactEnrichmentModule"));

var _NoCampaigns = _interopRequireDefault(require("./components/NoCampaigns/NoCampaigns"));

var _Step = _interopRequireDefault(require("./components/Step/Step"));

var _CampaignSummary = _interopRequireDefault(require("./components/CampaignSummary/CampaignSummary"));

var _GiftStatus = _interopRequireDefault(require("./components/GiftStatus/GiftStatus"));

var _PreviewLink = _interopRequireDefault(require("./components/PreviewLink/PreviewLink"));

var _ProductPriceInput = _interopRequireDefault(require("./components/ProductPriceInput/ProductPriceInput"));

var _ProductPriceDropdown = _interopRequireDefault(require("./components/ProductPriceDropdown/ProductPriceDropdown"));

var _MessageCard = _interopRequireDefault(require("./components/SendReview/MessageCard"));

var _DeliveryAddressForm = _interopRequireDefault(require("./components/DeliveryAddressForm/DeliveryAddressForm"));

var _marketplace = require("./store/marketplace/marketplace.actions");

var _useMarketplace = require("./hooks/useMarketplace");

var _useCampaigns = require("./hooks/useCampaigns");

var _gift = require("./store/gift/gift.types");

var _recipient = require("./store/recipient/recipient.actions");

var giftActions = _interopRequireWildcard(require("./store/gift/gift.actions"));

var _postcard = require("./store/gift/postcard");

var templateActions = _interopRequireWildcard(require("./store/templates/templates.actions"));

var _message = require("./store/gift/postcard/message/message.helpers");

var constants = _interopRequireWildcard(require("./constants"));

var campaignsActions = _interopRequireWildcard(require("./store/campaigns/campaigns.actions"));

var _createGift = require("./createGift.types");

Object.keys(_createGift).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createGift[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createGift[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CreateGift = {
  epic: _root.default,
  reducer: _root2.default,
  selectors,
  CreateGiftModule: _CreateGiftModule.default,
  CreateContactModule: _CreateContactModule.default,
  SendGiftModule: _SendGiftModule.default,
  EditContactModule: _EditContactModule.default,
  ContactEnrichmentModule: _ContactEnrichmentModule.default,
  SelectCampaign: _SelectCampaign.default,
  NoCampaigns: _NoCampaigns.default,
  CampaignSummary: _CampaignSummary.default,
  Step: _Step.default,
  constants,
  actionTypes: {
    GIFT_CREATE_SUCCESS: _gift.GIFT_CREATE_SUCCESS,
    GIFT_CREATE_SEND_SUCCESS: _gift.GIFT_CREATE_SEND_SUCCESS,
    GIFT_DISCARD_SUCCESS: _gift.GIFT_DISCARD_SUCCESS,
    GIFT_EXPIRE_SUCCESS: _gift.GIFT_EXPIRE_SUCCESS,
    GIFT_CANCEL_SUCCESS: _gift.GIFT_CANCEL_SUCCESS,
    CREATE_GIFT_RECIPIENT_CREATE_SUCCESS: _recipient.CREATE_GIFT_RECIPIENT_CREATE_SUCCESS
  },
  helpers: {
    convertGiftToMessage: _message.convertGiftToMessage,
    convertGiftWithShadowMessage: _message.convertGiftWithShadowMessage
  },
  actions: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _postcard.actions), giftActions), templateActions), campaignsActions), {}, {
    createRecipientRequest: _recipient.createRecipientRequest
  }),
  useCampaignsRequest: _useCampaigns.useCampaignsRequest
};
exports.CreateGift = CreateGift;